import { IBACPredesign } from '@/src/modules/build-a-card/types'
import { CUSTOM_CARD_IMAGE } from '@/src/common/constants'

function getDefaultPredesign({
    predesigns,
    setPredesignUuid,
    setDesignImage,
    setDesignName,
    defaultToPredesign,
}: {
    predesigns: IBACPredesign[]
    setPredesignUuid: Function
    setDesignImage: Function
    setDesignName: Function
    defaultToPredesign: boolean
}) {
    if (!defaultToPredesign) {
        setDesignName(CUSTOM_CARD_IMAGE)
        return
    }

    if ('undefined' === typeof window)
        return {
            uuid: '',
            preview_image_url: '',
            design_name: '',
            categories: [],
        }

    const urlParams = new URLSearchParams(window?.location?.search)
    const paramDesign = urlParams.get('design')?.replace(/_+/g, ' ')

    const predesign =
        predesigns.find(
            (design) =>
                design.design_name.toLowerCase() === paramDesign?.toLowerCase()
        ) ?? predesigns[0]

    setPredesignUuid(predesign.uuid)
    setDesignImage(predesign.preview_image_url)
    setDesignName(predesign.design_name)
}

export default getDefaultPredesign
